export function initTestimonialsSlider() {
  const root = document.querySelector('[data-slider]');
  if (!root) return;

  const track = root.querySelector('[data-slider-track]');
  const prevBtn = root.querySelector('[data-slider-prev]');
  const nextBtn = root.querySelector('[data-slider-next]');
  const dotsRoot = root.querySelector('[data-slider-dots]');

  if (!track || !prevBtn || !nextBtn || !dotsRoot) return;

  const slides = Array.from(track.children);
  let index = 0;
  let timer;

  const renderDots = () => {
    dotsRoot.innerHTML = '';
    slides.forEach((_, i) => {
      const btn = document.createElement('button');
      btn.className = 'dot-btn';
      btn.type = 'button';
      btn.setAttribute('aria-label', `Go to testimonial ${i + 1}`);
      btn.setAttribute('aria-current', i === index ? 'true' : 'false');
      btn.addEventListener('click', () => goTo(i));
      dotsRoot.appendChild(btn);
    });
  };

  const apply = () => {
    track.style.transform = `translateX(${-index * 100}%)`;
    const dotButtons = Array.from(dotsRoot.querySelectorAll('button'));
    dotButtons.forEach((btn, i) => btn.setAttribute('aria-current', i === index ? 'true' : 'false'));
    slides.forEach((slide, i) => {
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      slide.classList.toggle('is-active', i === index);
    });
  };

  const goTo = (i) => {
    index = (i + slides.length) % slides.length;
    apply();
    restart();
  };

  const next = () => goTo(index + 1);
  const prev = () => goTo(index - 1);

  const restart = () => {
    window.clearInterval(timer);
    timer = window.setInterval(next, 6500);
  };

  prevBtn.addEventListener('click', prev);
  nextBtn.addEventListener('click', next);

  // Pause on hover/focus for better UX
  root.addEventListener('mouseenter', () => window.clearInterval(timer));
  root.addEventListener('mouseleave', restart);
  root.addEventListener('focusin', () => window.clearInterval(timer));
  root.addEventListener('focusout', restart);

  renderDots();
  apply();
  restart();
}
